<template>
  <div
    class="join-footer"
    :class="{
      'is-en': currentLanguageIsEn,
      'member-footer': currentAbout.type,
    }"
    :style="themeData"
    @click="handleJoinUs"
  >
    <div
      class="fixed inset-x-0 bottom-0 z-20 h-12 rounded-t-2xl bg-[#3a190b] bg-cover bg-center bg-no-repeat px-3"
      :style="{
        bottom: `${bottom}px`,
        backgroundImage: `url(${joinFooterBg})`,
      }"
    >
      <div class="mx-auto flex h-12 items-center justify-between">
        <div
          class="ml-4 font-popR text-[15px] font-normal leading-[16.5px] text-white"
          :class="[
            currentLanguageIsEn ? '-skew-x-[5deg]' : '',
            isEn187 ? 'text-xs' : '',
          ]"
        >
          <template v-if="currentLanguageIsEn">
            Apply for
            <span
              class="font-popB text-[15px] font-medium"
              :class="isEn187 ? 'text-xs' : ''"
            >
              <template v-if="currentAbout.title"
                >{{ currentAbout.title }}
              </template>
              <template v-else>JCtrans</template>
              membership
            </span>
          </template>
          <template v-else>
            {{ $t('membership.overview.join') }}
          </template>
        </div>
        <div>
          <JcImg
            :level="1"
            src="https://resources.jctrans.com/res/era-h5/h5/img/joinus_arrow.gif"
            class="size-6"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { useRoute, useRouter } from 'vue-router'
  import { computed } from 'vue'
  import { go2JoinUs } from '~/utils/auth'

  import bgMemberJoinUs from '@/assets/images/membership/bg_member_joinus.png'
  import bgJoinUsE from '@/assets/images/membership/bg_joinus_e.jpg'
  import bgJoinUsPre from '@/assets/images/membership/bg_joinus_pre.jpg'
  import bgJoinUsRising from '@/assets/images/membership/bg_joinus_rising.jpg'
  import bgJoinUsPro from '@/assets/images/membership/bg_joinus_pro.jpg'
  import bgJoinUsDg from '@/assets/images/membership/bg_joinus_dg.jpg'
  import bgJoinUsEc from '@/assets/images/membership/bg_joinus_ec.jpg'
  import bgJoinUsRw from '@/assets/images/membership/bg_joinus_rw.jpg'
  import bgJoinUsV from '@/assets/images/membership/bg_joinus_v.jpg'
  import bgJoinUsJcvf from '@/assets/images/jcvf/bg_jcvf_joinus@2x.png'

  defineProps({
    bottom: {
      type: [Number, String],
      default: 0,
    },
  })

  const route = useRoute()
  const router = useRouter()
  const { getCurrent } = useMemberShipListNew()
  // 根据路由名获取 CRM marker
  const ROUTE_NAME_TO_CRM_MARKER = {
    Home: '首页-H5',
    membershipJCTransBenefitsOverview: '会员权益-H5',
    membershipJCTransIntroduction: '会员介绍-H5',

    membershipJCTransEliteNew: 'JCE-H5',
    membershipJCTransPremiumNew: 'JCP-H5',
    membershipJCTransRisingNew: 'JCR-H5',
    membershipJCTransProjectsAboutNew: 'JCPJ-H5',
    membershipJCTransDangerousGoodsAboutNew: 'JCDG-H5',
    membershipJCTransECommerceAboutNew: 'JCEC-H5',
    membershipJCTransRailwayAboutNew: 'JCRW-H5',
    membershipJCTransVendorNew: 'JCV-H5',
    membershipJCTransVendorDiscountNew: 'JCV-H5',

    shopHome: '商铺详情页-H5',

    logisticsNewsDetail: 'JCtrans新闻详情页H5',
    JctransNewsDetail: '行业新闻详情页H5',

    riskPreventionRiskNoticeDetail: '风险通知详情页-H5',
    riskPreventionRiskCaseDetail: '案例解析详情页-H5',
    membershipToolsRiskProcessDetail: '规则说明详情页-H5',

    Resources: '资讯中心H5',
    Blog: 'Blog标签列表H5',
    BlogSearch: 'Blog文章列表H5',
    BlogDetail: 'Blog文章详情H5',
    membershipJCVF: '新主站H5会员服务JCVF',
    knowledgeNewsDetail: '新主站H5货运知识详情',
    regionsNewsDetail: '新主站H5货运地区详情',
    experienceNewsDetail: '新主站H5货运经验详情',
    solutionsNewsDetail: '新主站H5货运解决方案详情',
    policyNewsDetail: '新主站H5货运政策详情',
  }

  // 会员申请的线索
  const ROUTE_NAME_TO_CLICK_SOURCE_FORM = {
    Home: 'PLT.APPLI.APPLY.H5_ERA_HOME_FORM',
    membershipJCTransBenefitsOverview:
      'PLT.APPLI.APPLY.H5_ERA_MEMBERSHIPJCTRANSBENEFITSOVERVIEW_FORM',
    membershipJCTransIntroduction:
      'PLT.APPLI.APPLY.H5_ERA_MEMBERSHIPJCTRANSINTRODUCTION_FORM',
    membershipJCTransEliteNew:
      'PLT.APPLI.APPLY.H5_ERA_MEMBERSHIPJCTRANSELITENEW_FORM',
    membershipJCTransPremiumNew:
      'PLT.APPLI.APPLY.H5_ERA_MEMBERSHIPJCTRANSPREMIUMNEW_FORM',
    membershipJCTransRisingNew:
      'PLT.APPLI.APPLY.H5_ERA_MEMBERSHIPJCTRANSRISINGNEW_FORM',
    membershipJCTransProjectsAboutNew:
      'PLT.APPLI.APPLY.H5_ERA_MEMBERSHIPJCTRANSPROJECTSABOUTNEW_FORM',
    membershipJCTransDangerousGoodsAboutNew:
      'PLT.APPLI.APPLY.H5_ERA_MEMBERSHIPJCTRANSDANGEROUSGOODSABOUTNEW_FORM',
    membershipJCTransECommerceAboutNew:
      'PLT.APPLI.APPLY.H5_ERA_MEMBERSHIPJCTRANSECOMMERCEABOUTNEW_FORM',
    membershipJCTransRailwayAboutNew:
      'PLT.APPLI.APPLY.H5_ERA_MEMBERSHIPJCTRANSRAILWAYABOUTNEW_FORM',
    membershipJCTransVendorNew:
      'PLT.APPLI.APPLY.H5_ERA_MEMBERSHIPJCTRANSVENDORNEW_FORM',
    membershipJCTransVendorDiscountNew:
      'PLT.APPLI.APPLY.H5_ERA_MEMBERSHIPJCTRANSVENDORDISCOUNTNEW_FORM',
    shopHome: 'PLT.APPLI.APPLY.H5_ERA_SHOPHOME_FORM',
    logisticsNewsDetail: 'PLT.APPLI.APPLY.H5_ERA_LOGISTICSNEWSDETAIL_FORM',
    JctransNewsDetail: 'PLT.APPLI.APPLY.H5_ERA_JCTRANSNEWSDETAIL_FORM',
    riskPreventionRiskNoticeDetail:
      'PLT.APPLI.APPLY.H5_ERA_RISKPREVENTIONRISKNOTICEDETAIL_FORM',
    riskPreventionRiskCaseDetail:
      'PLT.APPLI.APPLY.H5_ERA_RISKPREVENTIONRISKCASEDETAIL_FORM',
    membershipToolsRiskProcessDetail:
      'PLT.APPLI.APPLY.H5_ERA_MEMBERSHIPTOOLSRISKPROCESSDETAIL_FORM',
    Resources: 'PLT.APPLI.APPLY.H5_ERA_RESOURCES_FORM',
    Blog: 'PLT.APPLI.APPLY.H5_ERA_BLOG_FORM',
    BlogSearch: 'PLT.APPLI.APPLY.H5_ERA_BLOGLIST_FORM',
    BlogDetail: 'PLT.APPLI.APPLY.H5_ERA_BLOGDETAIL_FORM',
    membershipJCVF: 'PLT.APPLI.APPLY.H5_ERA_JCVF_APPLY_FORM',
    knowledgeNewsDetail: 'PLT.APPLI.APPLY.H5_ERA_KNOWLEDGE_NEWS_DETAIL_FORM',
    regionsNewsDetail: 'PLT.APPLI.APPLY.H5_ERA_REGIONS_NEWS_DETAIL_FORM',
    experienceNewsDetail: 'PLT.APPLI.APPLY.H5_ERA_EXPERIENCE_NEWS_DETAIL_FORM',
    solutionsNewsDetail: 'PLT.APPLI.APPLY.H5_ERA_SOLUTIONS_NEWS_DETAIL_FORM',
    policyNewsDetail: 'PLT.APPLI.APPLY.H5_ERA_POLICY_NEWS_DETAIL_FORM',
  }

  // 注册线索
  const ROUTE_NAME_TO_CLICK_SOURCE = {
    Home: 'PLT.REG.H5.H5_ERA_HOME',
    membershipJCTransBenefitsOverview:
      'PLT.REG.H5.H5_ERA_MEMBERSHIPJCTRANSBENEFITSOVERVIEW',
    membershipJCTransIntroduction:
      'PLT.REG.H5.H5_ERA_MEMBERSHIPJCTRANSINTRODUCTION',
    membershipJCTransEliteNew: 'PLT.REG.H5.H5_ERA_MEMBERSHIPJCTRANSELITENEW',
    membershipJCTransPremiumNew:
      'PLT.REG.H5.H5_ERA_MEMBERSHIPJCTRANSPREMIUMNEW',
    membershipJCTransRisingNew: 'PLT.REG.H5.H5_ERA_MEMBERSHIPJCTRANSRISINGNEW',
    membershipJCTransProjectsAboutNew:
      'PLT.REG.H5.H5_ERA_MEMBERSHIPJCTRANSPROJECTSABOUTNEW',
    membershipJCTransDangerousGoodsAboutNew:
      'PLT.REG.H5.H5_ERA_MEMBERSHIPJCTRANSDANGEROUSGOODSABOUTNEW',
    membershipJCTransECommerceAboutNew:
      'PLT.REG.H5.H5_ERA_MEMBERSHIPJCTRANSECOMMERCEABOUTNEW',
    membershipJCTransRailwayAboutNew:
      'PLT.REG.H5.H5_ERA_MEMBERSHIPJCTRANSRAILWAYABOUTNEW',
    membershipJCTransVendorNew: 'PLT.REG.H5.H5_ERA_MEMBERSHIPJCTRANSVENDORNEW',
    membershipJCTransVendorDiscountNew:
      'PLT.REG.H5.H5_ERA_MEMBERSHIPJCTRANSVENDORDISCOUNTNEW',
    shopHome: 'PLT.REG.H5.H5_ERA_SHOPHOME',
    logisticsNewsDetail: 'PLT.REG.H5.H5_ERA_LOGISTICSNEWSDETAIL',
    JctransNewsDetail: 'PLT.REG.H5.H5_ERA_JCTRANSNEWSDETAIL',
    riskPreventionRiskNoticeDetail:
      'PLT.REG.H5.H5_ERA_RISKPREVENTIONRISKNOTICEDETAIL',
    riskPreventionRiskCaseDetail:
      'PLT.REG.H5.H5_ERA_RISKPREVENTIONRISKCASEDETAIL',
    membershipToolsRiskProcessDetail:
      'PLT.REG.H5.H5_ERA_MEMBERSHIPTOOLSRISKPROCESSDETAIL',
    Resources: 'PLT.REG.H5.H5_ERA_RESOURCES',
    Blog: 'PLT.REG.H5.H5_ERA_BLOG',
    BlogSearch: 'PLT.REG.H5.H5_ERA_BLOGLIST',
    BlogDetail: 'PLT.REG.H5.H5_ERA_BLOGDETAIL',
    membershipJCVF: 'PLT.REG.H5.H5_ERA_JCVF_APPLY',
    knowledgeNewsDetail: 'PLT.REG.H5.H5_ERA_KNOWLEDGE_NEWS_APPLY',
    regionsNewsDetail: 'PLT.REG.H5.H5_ERA_REGIONS_NEWS_APPLY',
    experienceNewsDetail: 'PLT.REG.H5.H5_ERA_EXPERIENCE_NEWS_APPLY',
    solutionsNewsDetail: 'PLT.REG.H5.H5_ERA_SOLUTIONS_NEWS_APPLY',
    policyNewsDetail: 'PLT.REG.H5.H5_ERA_POLICY_NEWS_APPLY',
  }

  const MEMBER_FOOTER_BG: Record<string, string> = {
    JCE: bgJoinUsE,
    JCP: bgJoinUsPre,
    JCR: bgJoinUsRising,
    JCPJ: bgJoinUsPro,
    JCDG: bgJoinUsDg,
    JCEC: bgJoinUsEc,
    JCRW: bgJoinUsRw,
    JCV: bgJoinUsV,
    JCVF: bgJoinUsJcvf,
  }

  const DEFAULT_JOIN_BG =
    'https://resources.jctrans.com/res/era-h5/h5/img/bg_joinus.png'

  const currentAbout = computed(() => getCurrent(route.name as string))
  const currentTheme = computed(() => currentAbout.value?.theme || {})
  console.log(currentAbout.value, 'currentAbout', route.name)
  const system = useMySystemStore()

  const isAPP = computed(() => system.isAPP)

  const ROUTE_NAME_TO_JUMP_SOURCE = computed(() => {
    return isAPP.value
      ? {
          membershipJCTransIntroduction: 'PLT.APPLI.BENEFITS.INTRODUCTION',
          membershipJCTransBenefitsOverview: 'PLT.APPLI.BENEFITS.INTRODUCTION',
          membershipJCTransEliteNew: 'PLT.APPLI.BENEFITS.APP_JCE',
          membershipJCTransPremiumNew: 'PLT.APPLI.BENEFITS.APP_JCP',
          membershipJCTransRisingNew: 'PLT.APPLI.BENEFITS.APP_JCR',
          membershipJCTransProjectsAboutNew: 'PLT.APPLI.BENEFITS.APP_JCPJ',
          membershipJCTransDangerousGoodsAboutNew:
            'PLT.APPLI.BENEFITS.APP_JCDG',
          membershipJCTransECommerceAboutNew: 'PLT.APPLI.BENEFITS.APP_JCEC',
          membershipJCTransRailwayAboutNew: 'PLT.APPLI.BENEFITS.APP_JCRW',
          membershipJCTransVendorNew: 'PLT.APPLI.BENEFITS.APP_JCV',
          membershipJCTransVendorDiscountNew: 'PLT.APPLI.BENEFITS.APP_JCV',
          membershipJCVF: 'PLT.APPLI.JVF_CHANNEL',
        }
      : {}
  })

  const themeData = computed(() => {
    if (!currentTheme.value?.footer) return undefined
    const { color, gradientStart, gradientEnd } = currentTheme.value.footer

    return {
      '--default-color': color,
      '--gradient-start': gradientStart,
      '--gradient-end': gradientEnd,
    }
  })

  const currentLanguageIsEn = computed(() => {
    return system.language === 'en-US'
  })

  const isEn187 = computed(
    () =>
      currentLanguageIsEn.value &&
      String(currentAbout.value?.CRMMarker || '') === '187',
  )

  const joinFooterBg = computed(() => {
    const type = currentAbout.value?.type as string | undefined
    if (type && MEMBER_FOOTER_BG[type]) {
      return MEMBER_FOOTER_BG[type]
    }
    if (type) {
      return bgMemberJoinUs
    }
    return DEFAULT_JOIN_BG
  })

  const jumpsource = computed(() => {
    return route.query.jumpsource || ''
  })
  const { $trackEvent } = useNuxtApp()
  const handleJoinUs = () => {
    const crmMarker =
      ROUTE_NAME_TO_CRM_MARKER[
        route.name as keyof typeof ROUTE_NAME_TO_CRM_MARKER
      ] || '首页-H5'
    const jumpSourceList = ROUTE_NAME_TO_JUMP_SOURCE.value
    const routeJumpSource =
      jumpSourceList[route.name as keyof typeof jumpSourceList] || ''

    const markerClickSourceFORM =
      ROUTE_NAME_TO_CLICK_SOURCE_FORM[
        route.name as keyof typeof ROUTE_NAME_TO_CLICK_SOURCE_FORM
      ] || 'PLT.APPLI.APPLY.H5_ERA_HOME_FORM'

    const markerClickSource =
      ROUTE_NAME_TO_CLICK_SOURCE[
        route.name as keyof typeof ROUTE_NAME_TO_CLICK_SOURCE
      ] || 'PLT.REG.H5.H5_ERA_HOME'
    $trackEvent('triggerForm', {
      pageCode_var: route.meta.pageCode + '' || '-',
      formEntry_var:
        ROUTE_NAME_TO_CRM_MARKER[
          route.name as keyof typeof ROUTE_NAME_TO_CRM_MARKER
        ] || '-',
    })
    // 如果有jumpsource，则添加jumpsource
    const query: any = {
      crmMarker: crmMarker,
      jumpsource: routeJumpSource,
      markerClickSourceFORM,
      markerClickSource,
      formEntry:
        ROUTE_NAME_TO_CRM_MARKER[
          route.name as keyof typeof ROUTE_NAME_TO_CRM_MARKER
        ] || '-',
    }
    if (jumpsource.value) {
      query.jumpsource = jumpsource.value
    }

    go2JoinUs(
      query.crmMarker,
      query.jumpsource,
      query.markerClickSource,
      query.markerClickSourceFORM,
      query.formEntry,
    )
  }
</script>
